import { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Modal,
  Snackbar,
  Stack,
  Skeleton,
  TextField,
  Typography
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import LinkIcon from "@mui/icons-material/Link";
import EditIcon from "@mui/icons-material/Edit";
import { Close as CloseIcon } from "@mui/icons-material";
import { Getrequestcall } from "../../../request/Getrequest";
import {
  GET_USER_CONTACTS,
  SAVE_CHAT_GROUP_MASSAGES_FOR_MONTAGE,
  SAVE_CHAT_GROUP_USERS,
  SAVE_POSTS,
  SEND_CHAT_GROUP_FIREBASE_NOTIFY
} from "../../../constant/Apipath";
import { Postrequestcall } from "../../../request/Postrequest";
import { English } from "../../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import "../Montage.css";
import BuildIdEvent from "../../../common/BuildIdEvent";

export default function ShareMontages({ open, onClose, selectedMontage, loginData, dbValues }) {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Montages || {};
  const {
    BUTTON_MODAL_COPY_LINK = English.Montages.BUTTON_MODAL_COPY_LINK,
    BUTTON_MODAL_POST = English.Montages.BUTTON_MODAL_POST,
    BUTTON_MODAL_MORE = English.Montages.BUTTON_MODAL_MORE,
    BUTTON_MODAL_SHARE = English.Montages.BUTTON_MODAL_SHARE,
    BUTTON_MODAL_SEND_IN_CHAT = English.Montages.BUTTON_MODAL_SEND_IN_CHAT,
    TEXT_SNACKBAR_COPY_TO_CLIPBOARD = English.Montages.TEXT_SNACKBAR_COPY_TO_CLIPBOARD,
    TEXT_SHARE = English.Montages.TEXT_SHARE,
    TEXT_MESSAGE_PLACEHOLDER = English.Montages.TEXT_MESSAGE_PLACEHOLDER,
    BUTTON_SEND = English.Montages.BUTTON_SEND
  } = LanguageData || {};

  const montId = selectedMontage?.id;
  const [selectedUser, setSelectedUser] = useState(null);
  const [postModalOpen, setPostModalOpen] = useState(false);
  const [postContent, setPostContent] = useState("");
  const [userContacts, setUserContacts] = useState([]);
  const [chatModalOpen, setChatModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [snackFlag, setSnackFlag] = useState(false);
  const [isPosting, setIsPosting] = useState(false);
  const [isSendingChat, setIsSendingChat] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);

  const buildIdEvent = BuildIdEvent();

  const handleOpenPostModal = () => {
    setPostModalOpen(true);
  };

  const handleCopyLink = async () => {
    const value = `https://bimiscwebapi-montage-viewer.azurewebsites.net/?db=${dbValues}/&email=""/&montageId=${montId}`;
    try {
      await navigator.clipboard.writeText(value);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = value;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.body.removeChild(textArea);
    }
    setSnackFlag(true);
  };

  const handleClosePostModal = () => {
    setPostModalOpen(false);
  };

  useEffect(() => {
    if (open) {
      getContacts();
    }
  }, [open]);

  const handleOpenChatModal = (user) => {
    setSelectedUser(user);
    setChatModalOpen(true);
  };

  const getContacts = async () => {
    setContactLoading(true);
    try {
      let getResponseContacts = await Getrequestcall(
        `${GET_USER_CONTACTS}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      setUserContacts(getResponseContacts?.data?.data || []);
    } catch (error) {
      console.error("getContacts-> Error While Getting User Contact: ", error);
    } finally {
      setContactLoading(false);
    }
  };

  const onSendChatPressed = async () => {
    if (!selectedUser) return;
    setIsSendingChat(true);
    const baseUrl = "https://bimiscwebapi-montage-viewer.azurewebsites.net";
    const newUrl = `${baseUrl}/?db=${dbValues}/&email=unknown/&montageId=${selectedMontage.id}&name=${selectedMontage.name}&type=montage`;
    try {
      const saveListArray = [
        {
          Id: 0,
          ChatGroupId: 0,
          UserId: Number(selectedUser?.contactId),
          ModifiedBy: Number(loginData?.userInformation?.UserId),
          Muted: false
        }
      ];
      const chatGroupObj = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: saveListArray
      };
      const result = await Postrequestcall(
        SAVE_CHAT_GROUP_USERS,
        chatGroupObj,
        loginData?.accessToken
      );
      let chatGroupId = result?.data?.data?.[0]?.objData?.chatGroupId ?? 0;
      if (!chatGroupId) {
        console.error("onSendChatPressed-> Error As Chat Group Id Is Invalid Or Not Added");
        return;
      }
      let messagesArray = [
        {
          Id: 0,
          ChatGroupId: chatGroupId,
          FromUserId: Number(loginData?.userInformation?.UserId),
          ToUserId: Number(selectedUser?.contactId),
          MessageText: newUrl,
          MessageTypeId: 3,
          ModifiedBy: Number(loginData?.userInformation?.UserId)
        }
      ];
      if (message.trim() !== "") {
        messagesArray.push({
          Id: 0,
          ChatGroupId: chatGroupId,
          FromUserId: Number(loginData?.userInformation?.UserId),
          ToUserId: Number(selectedUser?.contactId),
          MessageText: message,
          MessageTypeId: 1,
          ModifiedBy: Number(loginData?.userInformation?.UserId)
        });
      }
      const sendChatObject = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: messagesArray
      };
      await Postrequestcall(
        SAVE_CHAT_GROUP_MASSAGES_FOR_MONTAGE,
        sendChatObject,
        loginData?.accessToken
      );
      let getMessagesText = [
        Number(loginData?.userInformation?.UserId),
        loginData?.userInformation?.FirstName,
        loginData?.userInformation?.LastName,
        loginData?.pictureUrl,
        chatGroupId,
        message,
        1,
        loginData?.ChatLanguage
      ];
      if (message.trim() !== "") {
        console.log("Sending chat message via BuildIdEvent:", getMessagesText);
        await buildIdEvent.sendMessage(getMessagesText);
      }
      let getMessagesUrl = [
        Number(loginData?.userInformation?.UserId),
        loginData?.userInformation?.FirstName,
        loginData?.userInformation?.LastName,
        loginData?.pictureUrl,
        chatGroupId,
        newUrl,
        3,
        loginData?.ChatLanguage
      ];
      await buildIdEvent.sendMessage(getMessagesUrl); // Sending message via BuildIdEvent system to update signal real time chat
      sendChatNotification(chatGroupId);
      setMessage("");
      setChatModalOpen(false);
      onClose();
    } catch (error) {
      console.error("onSendChatPressed-> Error While Sharing Data In Chat: ", error);
    } finally {
      setIsSendingChat(false);
    }
  };

  const sendChatNotification = async (chatGroupId) => {
    const obj = {
      ChatGroupId: chatGroupId,
      Notification: {
        ActionUrl: `${import.meta.env.REACT_APP_CONVERSATIONSCREEN}${chatGroupId}`,
        title: loginData?.userInformation?.FirstName,
        Body: `${loginData?.userInformation?.FirstName} has sent you a new montage.`,
        Tags: {
          chatGroupId: chatGroupId,
          chatGroupName: loginData?.userInformation?.FirstName
        }
      }
    };
    try {
      await Postrequestcall(`${SEND_CHAT_GROUP_FIREBASE_NOTIFY}`, obj, loginData?.accessToken);
    } catch (error) {
      console.error("sendChatNotification-> Error sending chat notification: ", error);
    }
  };

  const handleSendPost = async () => {
    setIsPosting(true);
    try {
      const savePostObj = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: true,
        ReturnRecordError: false,
        SaveList: [
          {
            Id: 0,
            FormatTypeId: 1,
            PostedByUserId: Number(loginData?.userInformation?.UserId),
            AppId: 27,
            AppRecordId: montId,
            Message: postContent?.trim() === "" ? selectedMontage?.name : postContent,
            Reported: false,
            ModifiedBy: Number(loginData?.userInformation?.UserId)
          }
        ]
      };
      await Postrequestcall(SAVE_POSTS, savePostObj, loginData?.accessToken);
      setPostModalOpen(false);
      onClose();
      setPostContent("");
    } catch (error) {
      console.log("handleSendPost-> Error When Sending Post: ", error);
    } finally {
      setIsPosting(false);
    }
  };

  const handleCloseSnackBar = () => {
    setSnackFlag(false);
    onClose();
  };

  let isSharing = false;

  const onShareClick = () => {
    onClose();

    const value = `https://bimiscwebapi-montage-viewer.azurewebsites.net/?db=${dbValues}/&email=""/&montageId=${montId}`;
    const message = `Check out this Montage on BuildID:\n\n${value}`;

    if (navigator.share) {
      if (isSharing) return;

      const shareData = {
        title: "Check out this Montage on BuildID:",
        text: message,
        url: value
      };

      isSharing = true;
      navigator
        .share(shareData)
        .catch((error) => console.error("onShareClick-> Error In Navigator When Sharing: ", error))
        .finally(() => {
          isSharing = false;
        });
    } else {
      try {
        const subject = encodeURIComponent("Check out this Montage on BuildID");
        const body = encodeURIComponent(message);
        const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
        window.location.href = mailtoLink;
        isSharing = false;
      } catch (error) {
        console.log("onShareClick-> Error In Navugator When Sharing (fallback): ", error);
      }
    }
  };

  const buttonOptions = [
    {
      label: BUTTON_MODAL_POST,
      icon: <EditIcon sx={{ color: "black" }} />,
      onClick: handleOpenPostModal
    },
    {
      label: BUTTON_MODAL_COPY_LINK,
      icon: <LinkIcon sx={{ color: "black" }} />,
      onClick: handleCopyLink
    },
    {
      label: BUTTON_MODAL_MORE,
      icon: <MoreHorizIcon sx={{ color: "black" }} />,
      onClick: onShareClick
    }
  ];

  return (
    <>
      <Modal open={open}>
        <Box className="user-modal-responsive">
          <Snackbar
            autoHideDuration={500}
            open={snackFlag}
            onClose={handleCloseSnackBar}
            message={TEXT_SNACKBAR_COPY_TO_CLIPBOARD}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            key={"bottomcenter"}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6"> {BUTTON_MODAL_SHARE}</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className="main-content-card-list">
            <Stack spacing={1} sx={{ pb: 1 }}>
              <Grid container spacing={1} columns={{ xs: 12, md: 12 }}>
                {buttonOptions.map((btn, index) => (
                  <Grid sx={{ justifyContent: "center", borderRadius: "10px" }} key={index} size={{ xs: 4, md: 4 }}>
                    <Box
                      key={index}
                      onClick={btn.onClick}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 1
                      }}>
                      <Button
                        key={index}
                        sx={{
                          p: 1,
                          height: "75px",
                          width: "100%",
                          flexDirection: "column",
                          alignItems: "center",
                          backgroundColor: "lightgray",
                          borderRadius: "10px"
                        }}
                        variant="contained"
                        onClick={btn.onClick}>
                        <Avatar sx={{ backgroundColor: "transparent" }}>{btn.icon}</Avatar>
                        <Typography variant="caption" sx={{ color: "black", fontWeight: "bold" }}>
                          {btn.label}
                        </Typography>
                      </Button>
                    </Box>
                  </Grid>
                ))}
              </Grid>
              {contactLoading ? (
                <Stack spacing={1}>
                  <Typography variant="h6">{BUTTON_MODAL_SEND_IN_CHAT}</Typography>
                  {[1, 2, 3].map((item) => (
                    <Card key={item} className="pagelist-content" sx={{ marginTop: "0px" }}>
                      <ListItemButton alignItems="center">
                        <ListItemAvatar>
                          <Skeleton variant="circular" width={40} height={40} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={<Skeleton variant="text" width="60%" />}
                          secondary={<Skeleton variant="text" width="40%" />}
                        />
                      </ListItemButton>
                    </Card>
                  ))}
                </Stack>
              ) : userContacts?.length > 0 ? (
                <>
                  <Typography variant="h6">{BUTTON_MODAL_SEND_IN_CHAT}</Typography>
                  <Box maxHeight={"250px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
                    <List disablePadding>
                      <Stack sx={{ gap: 1 }} >
                        {userContacts.map((user, index) => (
                          <Card
                            key={index.toString()}
                            className="pagelist-content"
                            sx={{ marginTop: "0px" }}>
                            <ListItemButton
                              alignItems="center"
                              onClick={() => handleOpenChatModal(user)}>
                              <ListItemAvatar>
                                <Avatar src={user?.contactPictureUrl || ""} alt={user?.tradeName} />
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  <Typography variant="body1" maxWidth={"300px"} noWrap>
                                    {user?.contactName}
                                  </Typography>
                                }
                                secondary={
                                  <Typography variant="body1" maxWidth={"200px"} noWrap>
                                    {user?.tradeName}
                                  </Typography>
                                }
                              />
                            </ListItemButton>
                          </Card>
                        ))}
                      </Stack>
                    </List>
                  </Box>
                </>
              ) : (
                <Stack sx={{ alignItems: "center", justifyContent: "center", py: 2 }} spacing={1}>
                  <Typography sx={{ textAlign: "left", width: "100%" }} variant="h6">
                    {BUTTON_MODAL_SEND_IN_CHAT}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    No contacts found
                  </Typography>
                </Stack>
              )}
            </Stack>
          </Box>
        </Box>
      </Modal>

      {postModalOpen && (
        <Modal open={postModalOpen}>
          <Box className="user-modal-responsive">
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
              }}>
              <Typography variant="h6"> {TEXT_SHARE} </Typography>
              <IconButton onClick={handleClosePostModal}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box className="main-content-card-list">
              <Stack spacing={1.5} sx={{ pt: 1 }}>
                <TextField
                  label={TEXT_MESSAGE_PLACEHOLDER}
                  multiline
                  rows={13}
                  fullWidth
                  value={postContent}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    if (/^[A-Za-z0-9\u{1F300}-\u{1FAFF}]/u.test(inputValue)) {
                    } else {
                      inputValue = inputValue.replace(/^[^A-Za-z0-9\u{1F300}-\u{1FAFF}]+/u, "");
                      inputValue = inputValue.replace(/[^A-Za-z0-9\u{1F300}-\u{1FAFF}\s]/gu, "");
                    }
                    setPostContent(inputValue);
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSendPost}
                  loading={isPosting}>
                  {BUTTON_MODAL_SHARE}
                </Button>
              </Stack>
            </Box>
          </Box>
        </Modal>
      )}

      {chatModalOpen && (
        <Modal open={chatModalOpen}>
          <Box className="user-modal-responsive">
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
              }}>
              <Typography variant="h6"> {BUTTON_MODAL_SEND_IN_CHAT} </Typography>
              <IconButton onClick={() => setChatModalOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box className="main-content-card-list">
              <Stack spacing={1.5} sx={{ pt: 1 }}>
                {selectedUser && (
                  <Card className="pagelist-content" sx={{ marginTop: "0px" }}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar
                          src={selectedUser.contactPictureUrl || ""}
                          alt={selectedUser?.tradeName}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography variant="body1" maxWidth={"300px"} noWrap>
                            {selectedUser?.contactName}
                          </Typography>
                        }
                        secondary={
                          <Typography variant="body1" maxWidth={"200px"} noWrap>
                            {selectedUser?.tradeName}
                          </Typography>
                        }
                      />
                    </ListItem>
                  </Card>
                )}
                <TextField
                  label={TEXT_MESSAGE_PLACEHOLDER}
                  multiline
                  rows={10}
                  fullWidth
                  value={message}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    if (/^[A-Za-z0-9\u{1F300}-\u{1FAFF}]/u.test(inputValue)) {
                    } else {
                      inputValue = inputValue.replace(/^[^A-Za-z0-9\u{1F300}-\u{1FAFF}]+/u, "");
                      inputValue = inputValue.replace(/[^A-Za-z0-9\u{1F300}-\u{1FAFF}\s]/gu, "");
                    }
                    setMessage(inputValue);
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={onSendChatPressed}
                  loading={isSendingChat}>
                  {BUTTON_SEND}
                </Button>
              </Stack>
            </Box>
          </Box>
        </Modal>
      )}
    </>
  );
}

